import { render, staticRenderFns } from "./call-to-action.vue?vue&type=template&id=62b67664"
import script from "./call-to-action.vue?vue&type=script&lang=js"
export * from "./call-to-action.vue?vue&type=script&lang=js"
import style0 from "./call-to-action.vue?vue&type=style&index=0&id=62b67664&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports